import {forOwn, isElement, isFunction, isObject} from 'lodash';

export const deepFreeze = object =>
    forOwn(Object.freeze(object), value => {
        if (
            value &&
            value !== object &&
            (isObject(value) || isFunction(value)) &&
            !isElement(value) &&
            !Object.isFrozen(value)
        ) {
            deepFreeze(value);
        }
    });

const freezer = store => next => action => {
    const result = next(action);
    deepFreeze(store.getState());

    return result;
};

export default freezer;
